import { useMutation } from "@tanstack/react-query";
import { unauthedV3Request } from "utils/api/requests";

/**
 * Self-serve re-mint from the expired-link page: POST the confirmation email;
 * on success rails mints a fresh token and emails it to the batch's known
 * notification address (never the submitted one).
 *
 * The endpoint answers 202 with an EMPTY body on every call (uniform,
 * anti-enumeration — it never signals whether the token or email matched). The
 * shared JSON parser (utils/request) resolves an empty 2xx body to `{}`, so
 * that reads as success directly. A real HTTP error (429 rate-limit, 5xx) or a
 * network/timeout failure rejects, so the UI can prompt a retry — never
 * silently swallowed.
 *
 * @param {string} token - the (expired) download token from the URL
 * @param {object} [options] - react-query mutation options (onSuccess/onError)
 */
export const useResendLink = (token, options = {}) =>
  useMutation({
    mutationFn: ({ email }) =>
      unauthedV3Request(`v3/downloads/${encodeURIComponent(token)}/resend`, {
        method: "POST",
        body: JSON.stringify({ email }),
      }),
    ...options,
  });
